import { ReactNode, FC } from "react";
import { Box } from "@mui/material";

import PageHeader from "../PageHeader/PageHeader";
import { DEFAULT_BACKGROUND_COLOR } from "../consts";
import { PAGE_TOP_OFFSET } from "consts/styles";

export type HeaderProps = {
    stickyHeader?: boolean;
    responsive?: boolean;
    HeaderComponent?: FC<{ children: ReactNode }>;
    headerProps?: {
        title: string | ReactNode;
        toolbar?: ReactNode;
    };
};

const Header = ({
    stickyHeader,
    responsive,
    HeaderComponent,
    headerProps,
}: HeaderProps) => {
    const Header: ReactNode = headerProps ? (
        <PageHeader {...headerProps} responsive={responsive} />
    ) : null;

    return (
        <Box
            id="pageHeader"
            sx={
                // prettier-ignore
                stickyHeader
                    ? {
                        position: "sticky",
                        top: PAGE_TOP_OFFSET,
                        backgroundColor: DEFAULT_BACKGROUND_COLOR,
                        zIndex: 2
                    }
                    : undefined
            }
        >
            {HeaderComponent ? (
                <HeaderComponent>{Header}</HeaderComponent>
            ) : (
                Header
            )}
        </Box>
    );
};

export default Header;
